import { Mail, Phone } from "lucide-react";
import { siteData } from "@/lib/aht/pageData";
import { Logo } from "@/components/aht/Logo";
import { fill } from "@/lib/aht/format";

// Branded page for anything that is not a live proposal: unknown code, root, withdrawn, expired.
// Never lists or links proposals.
export function StatusPage({ kind }) {
  const { ui, agent } = siteData;
  const s = ui.status;
  const expired = kind === "expired";
  return (
    <main className="flex min-h-screen flex-col items-center justify-center bg-paper px-6 py-16 text-center text-ink" data-testid={`status-${kind}`}>
      <Logo height={56} testId="status-logo" />
      <p className="t-intro mt-10 max-w-[40ch] text-balance" data-testid="status-message">
        {expired ? s.expired : fill(s.notAvailable, { phone: agent.phone, email: agent.email })}
      </p>
      {expired && (
        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <a href={agent.phoneHref} className="btn btn-primary min-w-[160px]" data-testid="status-call-button">
            <Phone size={18} strokeWidth={1.75} aria-hidden="true" />
            {s.call}
          </a>
          <a href={`mailto:${agent.email}`} className="btn btn-secondary min-w-[160px]" data-testid="status-email-button">
            <Mail size={18} strokeWidth={1.75} aria-hidden="true" />
            {s.email}
          </a>
        </div>
      )}
    </main>
  );
}
